/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedPeopleMultipleQueryResponse,
  GetApiV1PersonSharedPeopleMultipleQueryParams,
  GetApiV1PersonSharedPeopleMultiple401,
  GetApiV1PersonSharedPeopleMultiple500,
} from "../../types/courseRegistrationSharedController/GetApiV1PersonSharedPeopleMultiple.ts";

function getGetApiV1PersonSharedPeopleMultipleUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/people-multiple` as const,
  };
  return res;
}

/**
 * @description Retorna pessoas filtradas por nome, tipo e empresa para uso em campos de seleção múltipla. Usuários com papel Polo recebem apenas pessoas vinculadas aos seus polos. A chave retornada tem o prefixo 'USR' (ex.: 'USR123'). **(Requer Authorization para autenticação)**
 * @summary Retorna lista de pessoas para seleção múltipla (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/people-multiple}
 */
export async function getApiV1PersonSharedPeopleMultiple(
  params?: GetApiV1PersonSharedPeopleMultipleQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedPeopleMultipleQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedPeopleMultiple401
      | GetApiV1PersonSharedPeopleMultiple500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedPeopleMultipleUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
